<template>
  <modal v-if="isShow" redesign is_big :is-close-disabled="isCloseDisabled" @close="$emit('close')">
    <div slot="header">
      <h3>{{ $tr('rates.popup.responsesTitle') }}</h3>
    </div>

    <div slot="body">
      <div class="body">
        <div class="body-text">
          {{ $tr('rates.popup.responsesText') }}
        </div>
        <div v-tooltip="{ content: $tr('rates.continueInfo'), placement: 'auto', classes: 'tight' }" class="option">
          <input id="responses-continue" v-model="responseLimitExpiredAction" type="radio" value="1" />
          <label for="responses-continue"> </label>
          <span class="option-description" @click="responseLimitExpiredAction = 1">
            {{ $tr('rates.continueTesting') }}
          </span>
        </div>

        <div v-tooltip="{ content: $tr('rates.stopInfo'), placement: 'auto', classes: 'tight' }" class="option">
          <input id="responses-stop" v-model="responseLimitExpiredAction" type="radio" value="0" />
          <label for="responses-stop"> </label>
          <span class="option-description" @click="responseLimitExpiredAction = 0">{{ $tr('rates.stopTesting') }}</span>
        </div>
      </div>
    </div>

    <div slot="footer">
      <div class="buttons-wrapper">
        <vbutton v-if="!showCustomButtons" label="rates.save" @click="save" />
        <slot v-else name="buttons"></slot>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'RatesResponsesPopup',

  components: {
    Modal
  },

  props: {
    showCustomButtons: {
      type: Boolean,
      default: false
    },

    isShow: {
      type: Boolean,
      default: false
    },

    isCloseDisabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      responseLimitExpiredAction: '0'
    };
  },

  computed: {
    ...mapGetters('company', { company: 'one' })
  },

  methods: {
    ...mapActions('company_new', ['update_rates']),

    save() {
      this.update_rates({ company_id: this.company.id, save_no_paid_responses: this.responseLimitExpiredAction }).then(
        () => {
          this.$noty.success(this.$tr('rates.saveSuccess'));
          this.$emit('close');
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.body {
  font-size: 16px;
  line-height: 23px;
  margin-bottom: 20px;
  margin-top: 20px;
}

.body-text {
  margin-bottom: 40px;
}

.option {
  display: flex;
  margin-bottom: 20px;

  label {
    margin-top: 2px;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.option-description {
  display: inline-block;
  margin-left: 10px;
  cursor: pointer;
}
</style>
